import { type FC } from 'react'

import type { ProspectDto } from '@api'
import { Image, Text, View } from '@react-pdf/renderer'

import accountImage from '@/assets/images/account-circle.png'

import { styles } from '../styles'

interface Props {
  data: ProspectDto
}

export const ReportHeader: FC<Props> = ({ data }) => {
  if (!data.id) {
    return null
  }

  return (
    <View style={styles.block}>
      <View style={styles.card}>
        <View style={styles.accountWrapper}>
          <Image
            src={accountImage}
            style={styles.avatar}
          />
          <Text style={styles.headerSubtitle}>{data.name}</Text>
        </View>
      </View>
    </View>
  )
}
